// extracted by mini-css-extract-plugin
module.exports = {"facts_v1":"Faktaboks_facts_v1__t_UJA","factIcon":"Faktaboks_factIcon__cClvJ","decorated":"Faktaboks_decorated__PBHIJ","facts_v2":"Faktaboks_facts_v2__kdFb5"};